// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__vZbbC","tab":"style_tab__8X4ed","active":"style_active__QK5JY"};